import { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import equals from 'ramda/src/equals';
import Button from '@components/@core/AnimatedButton';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import Input from '@components/@core/Input';
import CommunityActions from '~/actions/community';
import { validateEmail } from '~/services/util';

const Edit = ({ user =  {id: 0}, avatar = '', cover = '', onCancel = () => {}}) => {
    const dispatch = useDispatch();
    const avatarRef = useRef(avatar);
    const [prevUser, setPrevUser] = useState(null);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [infoBio, setInfoBio] = useState('');
    const [phone, setPhone] = useState('');
    const [office, setOffice] = useState('');
    const [email, setEmail] = useState('');
    const emailError = validateEmail(email) ? '' : 'Enter Valid email';
    const disabled =
        firstName === (user.first_name ?? '') &&
        lastName === (user.last_name ?? '') &&
        infoBio === (user.profile?.info_bio ?? '') &&
        phone === (user.profile?.contact_phone ?? '') &&
        office === (user.profile?.office ?? '') &&
        email === (user.profile?.contact_email ?? '') &&
        cover === user.cover_url &&
        avatar === user.avatar &&
        avatar === avatarRef.current;

    useEffect(() => {
        if (!equals(prevUser, user)) {
            setPrevUser(user);
            setFirstName(user.first_name || '');
            setLastName(user.last_name || '');
            setInfoBio(user.profile?.info_bio || '');
            setEmail(user.profile?.contact_email || user?.email || '');
            setPhone(user.profile?.contact_phone || '');
            setOffice(user.profile?.office || '');
        }
    }, [user]);

    const handleSave = () => {
        const payload = {
            data: {
                user: {
                    ...user,
                    avatar,
                    cover_url: cover,
                    first_name: firstName,
                    last_name: lastName,
                    email,
                    email2: null,
                    profile: {
                        ...user.profile,
                        info_bio: infoBio,
                        contact_phone: phone,
                        contact_email: email,
                        office,
                    },
                },
            },
            after: null,
            callback: onCancel,
        };
        dispatch(CommunityActions.postcommunityuserRequest(payload));
    };

    return (
        <ErrorBoundary className="individual-profile-about">
            <div className="card">
                <p className="dsl-b24 bold">Edit About Information</p>
                <Row className="mx-0">
                    <Col xs={12} sm={6} className="pl-0">
                        <Input className="mb-3" title="First Name" value={firstName} onChange={(e) => setFirstName(e)} />
                        <Input className="mb-3" title="Last Name" value={lastName} onChange={(e) => setLastName(e)} />
                    </Col>
                    <Col xs={12} sm={6}>
                        <Input className="mb-3" title="Cell" value={phone} placeholder="000 333 4455" pattern={/[^0-9.]/g} onChange={(e) => setPhone(e)} />
                        <Input className="mb-3" title="Office" value={office} placeholder="1 323 653 8899" pattern={/[^0-9.]/g} onChange={(e) => setOffice(e)} />
                        <Input className="mb-3" title="Email" value={email} placeholder="email@email.com" error={emailError} onChange={(e) => setEmail(e)} />
                    </Col>
                </Row>
            </div>
            <div className="d-h-end mt-3 mb-3 ssm-b-3 pb-0 ssp-b-3">
                <Button type="low" name="DISCARD" className="mr-3" onClick={onCancel} />
                <Button name="SAVE" disabled={disabled} onClick={handleSave} />
            </div>
        </ErrorBoundary>
    );
};

Edit.propTypes = {
    user: PropTypes.shape({
        id: PropTypes.number,
    }),
    avatar: PropTypes.string,
    cover: PropTypes.string,
    onCancel: PropTypes.func,
};

export default Edit;
